import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { UserPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface UserApplicationRoleModel {
    userId: number
    applicationRoleId: number
}

const AddUserApplicationrolePopup: React.FC<UserPopupProps> = ({ show, onHide, userId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<UserApplicationRoleModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const roles = useSelectListOptions('api/v1/selectlist/ApplicationRoles', '-- Select role');

    const [formData, setFormData] = useState<UserApplicationRoleModel>({
        userId: userId,
        applicationRoleId: 0,
    });

    function submit() {
        if (formData) {
            DataService
                .create<UserApplicationRoleModel>(`api/v1/UserApplicationRoles`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'applicationRoleId', label: 'Role', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Role'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('applicationRoleId')} options={roles} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserApplicationrolePopup;